import styled from 'styled-components';

import {
	EXCHANGE_PANEL_BACKGROUND_LEFT,
	EXCHANGE_PANEL_BACKGROUND_RIGHT,
	BASIC_PLAN_BACKGROUND,
	CRYPTO_PRO_PLAN_BACKGROUND,
	FIAT_MASTER_PLAN_BACKGROUND,
} from '../../config/media';

const Wrapper = styled.div`
	/* background-color: #F8F8F9; */
	background-color: #29292c;
	height: 100%;
	width: 100%;
	.ant-btn-primary {
		height: 49px;
	}
	.main-panel {
		background-color: #0e0e0f;
		height: 265px;
		text-align: center;
		position: relative;
		z-index: 1;
		h2 {
			padding-top: 25px;
			margin-bottom: 0.25rem;
		}
		.title {
			font-size: 26px;
			color: #ffffff;
			letter-spacing: 1px;
		}
		.sec-title {
			font-size: 14px;
			color: #a8a8b1;
			letter-spacing: 0.25px;
		}
	}
	.main-panel-1 {
		height: 120px !important;
	}
	.main-panel-1::after {
		height: 120px !important;
	}
	.main-panel::after {
		background-image: url(${EXCHANGE_PANEL_BACKGROUND_LEFT}),
			url(${EXCHANGE_PANEL_BACKGROUND_RIGHT});
		background-repeat: no-repeat, no-repeat;
		background-position: left -419px top -382px, right -740px bottom -671px;
		background-size: 1664px, 1926px 949px;
		content: '';
		opacity: 0.7;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		position: absolute;
		z-index: -1;
		height: 265px;
	}

	.form-container {
		background-color: #29292c;
		margin: auto;
		padding-bottom: 22px;
		.ant-form-item {
			padding: 5px 0;
			/* margin-bottom: 30px; */
		}
		.asset-form {
			.ant-form-item {
				margin-bottom: 12px;
			}
		}
		.pair-form {
			.ant-form-item {
				margin-bottom: 17px;
			}
		}
		.ant-form-item.last {
			border-bottom: 0;
		}
		.ant-form-item.role {
			border-bottom: 0;
			padding-bottom: 0;
		}
		h3,
		p {
			line-height: 1.2;
		}
	}
	.new-asset {
		margin-bottom: 20px;
		.add-asset {
			color: #3a4fff;
			font-size: 16px;

			display: flex;
			align-items: center;
			padding-left: 10px;
			span {
				padding-left: 8px;
				line-height: 22px;
				vertical-align: top;
				cursor: pointer;
			}
		}
		.steps-dash-link {
			color: #fff;
			margin-bottom: 8%;
			margin-left: 1%;
		}
	}
	.coin-spacing {
		margin: 20px 0px;
		width:30rem;
		.coin-list {
			display: flex;
			padding: 6px 12px;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #a8a8b1;
			> div {
				display: flex;
				flex: 1;
				/* width: 0%; */
				span {
					padding-left: 12px;
					color: #ffffff;
				}
				.rm-left {
					padding-left: 3px;
					cursor: pointer;
				}
			}
			.coin-item {
				line-height: 25px !important;
				padding-right: 1rem;
				display: flex;
				align-items: center;;
			}

			.x-mark {
				position: relative;
				&::before {
					content: 'X';
					font-size: 22px;
					display: block;
					width: 50px;
					text-align: center;
					color: #ffffff;
					position: absolute;
					/* right: 14px; */
					left: 45%;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			// &:last-child {
			// 	padding-bottom: 45px;
			// 	border-bottom: 1px solid #c0c0c0;
			// }
			.icons {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				color: #3a4fff;
				.rm-left {
					color: #3a4fff;
				}
				.divide {
					color: #808083;
					font-size: 22px;
					padding: 0 8px;
				}
				.anticon {
					font-size: 17px !important;
				}
			}

          		.ant-tag {
                margin:8px;
                color:rgba(0, 0, 0, 0.65) !important;
                padding: 1px 6px;
                font-size:10px;
            }
        }
    }
@media (max-width:280px) {
    width: 400px !important;
	.animation-container {
		.comment-box {
			width: 300px;
		}
	}
}
@media (max-width:350px) {
    .coin-spacing {
        width:100%;
        .x-mark {
                &::before {
                    font-size: 16px !important;
                    left: 25% !important; 
                    top: 53% !important;
                 } 
            }
    }
}   
@media (max-width:395px) {
    width: auto;
	.coin-spacing {
		.coin-list {
			.icons {
				.anticon {
					font-size: 14px !important;
				}
			}
			.ant-tag {
                margin:auto;
                padding: 0px 4px;
                font-size:8px;
            }
		}
    }
}

@media (max-width:600px) {
    .coin-spacing{
        width: 100%;
    }
}
`;

export const CofirmationWrapper = styled.div`
	.remove-confirmation-wrapper {
		color: #ffffff;
		.title {
            font-size: 18px;
    		font-weight: normal;
        }
		.sub-text {
			color: #A8A8B1;
			margin-top: 0.5rem;
		}
		.coin {
			display: flex;
			margin-top: 1rem;
		}
		.flex-container {
			display: flex;
			justify-content: space-between;
			width: 8rem;
		}
		.x-mark {
			position: relative;
			&::before {
				content: 'X';
				font-size: 22px;
				display: block;
				width: 50px;
				text-align: center;
				color: #ffffff;
				position: absolute;
				/* right: 14px; */
				left: 95%;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.coin-item {
			display: flex;
    		align-items: center;
			margin-left: 1rem;
		}
		.btn-wrapper {
			display: flex;
			justify-content: space-between;
			margin-top: 2rem;
			.ant-btn {
				width: 45%;
				height: 2.5rem;
			}
    	}
	}
`

export const FormWrapper = styled.div`
	width: 356px;
	margin: auto;
	.item-container {
		margin-bottom: 0px !important;
		padding: 0px !important;
	}
	.para-content {
		width: 340px;
		line-height: 1.5 !important;
		margin-left: 10px;
		margin-bottom: 20px;
	}
	.ant-input {
		height: 37px;
		margin-bottom: 5px;
	}
	.ant-select-selection--single {
		height: 37px;
	}
	@keyframes keyName-long {
		0% {
			transform: scale(0.6);
		}
		100% {
			transform: scale(1.05);
		}
	}
	@keyframes keyName-short {
		0% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}
	@keyframes mymove-bottom {
		from {
			-webkit-transform: translate3d(-200.9466px, -102.47586px, 0);
			opacity: 0;
		}
		to {
			-webkit-transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}
	@keyframes mymove-right {
		from {
			right: -30px;
		}
		to {
			right: 0px;
		}
	}
	.animation-container-1 {
		width: 450px;
		margin-top: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		.image-container {
			text-align: center;
			/* padding-top: 35px; */
			.image-content {
				border-radius: 50%;
				width: 50px;
			}
		}
		.text-content {
			color: #a8a8b1;
			width: 100px;
			margin-top: 20px;
			text-align: center;
		}
		.button-container-1 {
			margin-top: 20px;
			.button-pointer {
				border: solid 15px transparent;
				border-right-color: #3a4fff;
				position: absolute;
				margin: 0px 0px 0px -21px;
				z-index: 999;
			}
			Button {
				width: 59px;
				border-radius: 40px;
				height: 30px;
				font-size: 10px;
				span {
					margin-left: 1px;
					font-size: 11px;
				}
			}
		}
	}
	.animation-container {
		display: flex;
		width: 400px;
		justify-content: space-between;
		margin-top: 40px;
		.image-container {
			text-align: center;
			padding-top: 35px;
			position: relative;
			animation: mymove-right 0.5s;
			.image-content {
				border-radius: 50%;
				width: 40px;
			}
		}
		.text-content {
			color: #a8a8b1;
			font-style: italic;
			font-size: 12px;
			width: 80px;
			margin-top: 20px;
			text-align: center;
		}
		.message-container {
			animation: keyName-long 1s ease-out forwards;
		}
		.c-box {
			animation: keyName-short 1s ease;
		}
		.comment-box {
			background-color: #212121;
			color: #a8a8b1;
			width: 315px;
			padding: 20px;
			display: flex;
			border-radius: 15px;
		}
		.pointer {
			border: solid 20px transparent;
			border-right-color: #212121;
			position: absolute;
			margin: 40px 0 0 -38px;
			z-index: 999;
		}

		.comment-box {
			.confirmation-container {
				font-size: 12px;
				color: #ffffff;
				display: flex;

				.pr-1 {
					padding-right:0.5rem;
				}

				div {
					padding-bottom: 1rem;

					.steps-wrapper {
						padding-left: 20px;
					}
					p {
						margin-bottom: 5px;
						color: #ffffff;
						text-align: left;
						font-size: 11px;
					}
				}
			}

		}

		.button-container {
			display: flex;
			justify-content: end;
			margin-top: 20px;
			position: relative;
			animation: mymove-bottom 1s;
			Button {
				width: 80px;
				border-radius: 40px;
				height: 40px;
				font-size: 12px;
			}
		}
	}
	.animation-bounce {
		animation: bounce 0.9s ease;
		animation-delay: 1.1s;
	}
	@keyframes bounce {
		60% {
			transform: translateY(0%);
		}
		70% {
			transform: translateY(-9%);
		}
		80% {
			transform: translateY(0%);
		}
		90% {
			transform: translateY(-3%);
		}
	}
	.smooth-drop {
	}
	.align-center {
		display: flex;
		justify-content: center;
		.details-container {
			color: #fff;
			display: flex;
			align-items: center;
			height: 30px;
			border: 1px solid #5d5d6b;
			/* margin-top: 20px; */
			margin-bottom: 25px;
			background-color: #42454d;
			border-radius: 20px;
			width: 85%;
			font-size: 12px;
			span {
				color: #a8a8b1;
			}
			.info-icon {
				background-color: #3a4fff;
				color: white;
				border-radius: 50%;
				margin: 5px;
				height: 20px;
				width: 20px;
				display: flex;
				justify-content: center;
				font-size: 14px;
			}
		}
	}
	.divider {
		border-bottom: 1px solid #a8a8b1;
		width: 25rem;
	}
	.hosting-form {
		width: 500px !important;
	}
	.mt-1 {
		margin-top: 0.5rem !important;
	}
	.mb-1 {
		margin-bottom: 0.5rem !important;
	}
	.my-2 {
		margin: 1rem 0rem;
	}
	.m-2 {
		margin: 1rem;
	}
	.general-form {
		.form-label {
			margin-bottom: 5px;
		}
		p {
			line-height: 1.4;
		}
	}
	.form-label {
		color: #ffffff;
		font-size: 16px;
		vertical-align: middle;
		margin-top: 25px;

		font-weight: bold;
		span {
			font-weight: bold;
		}
	}
	p {
		color: #a8a8b1;
		font-size: 12px;
	}
	.payment-icon {
		margin: auto 0.5rem;
		width: 3rem;
	}
	.payment-mini-wrapper {
		align-items: center;
		border-radius: 50%;
		border: 1px solid #707070;
		display: flex;
		height: 2rem;
		justify-content: center;
		margin: 0px 0.5rem;
		width: 2rem;
	}
	.bottom-text {
		color: #a8a8b1;
		.link {
			color: #3a4fff;
		}
	}
	.payment-mini-icon {
		// margin: auto 0.5rem;
		width: 1.5rem;
	}
	.d-flex {
		display: flex;
	}
	.content-text-medium {
		font-size: 12px;
	}
	.content-text-small {
		font-size: 11px;
	}
	.content-text-mini {
		font-size: 10px;
	}
	.head {
		font-weight: bold;
		color: #ffffff;
	}
	.description-wrapper {
		border-bottom: 0px !important;
		padding-bottom: 10px !important;
	}
	.hosting-wrapper {
		.interface-box {
			.small-text {
				ul {
					padding-left: 20px;
					margin-bottom: 0px;
				}
			}
		}
		.plan-detail-box {
			display: none;
		}
		.in-active-menu:hover {
			.detail-icon {
				font-size: 18px;
				margin: 0px 5px;
			}
			.plan-detail-box {
				display: flex;
				align-items: center;
				background-color: #e4e5e6;
				height: 65px;
				position: absolute;
				right: 16px;
				top: 30px;
				width: 50%;
				font-size: 12px;
				margin-left: 5px;
				color: #808083;
				word-break: break-word;
				white-space: normal;
				border-radius: 13px;
				padding: 5px;
			}
		}
	}
	.ant-form-item.last {
		border-bottom: 0;
		padding: 0;
	}
	.ant-radio-group {
		width: 100%;
		margin-top: 21px;
		&.sub-radio {
			margin-top: 12px;
		}
	}
	.ant-radio-wrapper {
		display: block;
		padding: 24px 12px;
	}
	.theme-box {
		.ant-radio-wrapper {
			padding: 32px 12px;
		}
	}
	.ant-radio-wrapper-checked {
		/* border: 1px solid #0000ff; */
	}

	.file-container {
		border: 1px solid #b9b9b9;
		display: block;
		padding: 0 8px;
		padding-left: 90px;

		margin-top: 12px;
		white-space: nowrap;
		position: relative;
		img {
			position: absolute;
			top: 0px;
			left: 0px;
			display: block;
			width: 90px;
			height: 86px;
			object-fit: fill;
			cursor: pointer;
		}
		.ant-spin {
			position: absolute;
			top: 25px;
			left: 25px;
		}
		label {
			display: block;
			padding: 12px;
			padding-bottom: 0;
			box-sizing: border-box;
			height: 86px;
			border-left: 1px solid #b9b9b9;
			.anchor {
				color: #3a4fff;
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.ant-form-item-control {
			line-height: 1;
		}
		input {
			opacity: 0;
			position: fixed;
			left: -999px;
		}
		&::after {
			content: '';
			display: table;
			clear: both;
		}
	}
	.btn-area {
		border: 1px solid #3a4fff;
		margin-top: 8px;
		display: flex;
		> * {
			flex: 1;
		}
		.local {
			line-height: 1;
		}
		.ant-btn-primary {
			border: 0px;
		}
		button {
			font-weight: normal !important;
		}
	}
	.global-menu {
		display: flex;
		align-items: center;
	}
	.mini-icon {
		margin-right: 5px;
		width: 1rem;
	}
	.flag-icon {
		margin-right: 5px;
		width: 1.5rem;
	}
	.interface-box {
		.ant-radio-group {
			height: 140px;
		}
		.ant-radio-wrapper {
			padding: 32px 20px;
			color: #000;
			width: 100%;
			background-color: #212121;
			margin-bottom: 20px;
			overflow: hidden;
			height: 80px;
			opacity: 0.6;
		}
	}
	.flex-container {
		display: flex;
		justify-content: space-between;
	}
	.ant-radio-inner {
		width: 20px;
		height: 20px;
	}
	.selected-basic,
	.selected-crypto,
	.selected-fiat {
		.ant-radio-inner,
		.ant-radio-input:focus + .ant-radio-inner {
			border-width: 5px;
		}
	}
	.unselect-basic-layout {
		height: 3px;
		background-color: #c4c8ac;
		border-top-left-radius: 2px;
		border-top-right-radius: 2px;
	}
	.basic-layout {
		height: 10px;
		background-color: #c4c8ac;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}
	.unselect-crypto-layout {
		height: 3px;
		background-color: #5cb5f9;
		border-top-left-radius: 2px;
		border-top-right-radius: 2px;
	}
	.crypto-layout {
		height: 10px;
		background-color: #5cb5f9;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}
	.unselect-fiat-layout {
		height: 3px;
		background-color: #00ffff;
		border-top-left-radius: 2px;
		border-top-right-radius: 2px;
	}
	.fiat-layout {
		height: 10px;
		background-color: #00ffff;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}
	.basic-plan,
	.crypto_pro-plan,
	.fiat_master-plan {
		position: relative;
		z-index: 1;
		height: 76px;
		animation: hideMe 0.5s forwards;
	}
	.greentxt {
		color: #10ad16;
		font-size: 12px;
	}
	.in-active-menu {
		height: 30px;
		animation: mymove 0.5s;
	}
	.basic-plan::before {
		content: '';
		background-position: right;
		background-size: contain;
		background-image: url(${BASIC_PLAN_BACKGROUND});
		background-repeat: no-repeat;
		background-color: #212121;
		opacity: 0.6;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		z-index: -1;
	}
	.crypto_pro-plan::before {
		content: '';
		background-position: right;
		background-size: contain;
		background-image: url(${CRYPTO_PRO_PLAN_BACKGROUND});
		background-repeat: no-repeat;
		background-color: #212121;
		opacity: 0.6;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		z-index: -1;
	}
	.fiat_master-plan::before {
		content: '';
		background-image: url(${FIAT_MASTER_PLAN_BACKGROUND});
		background-position: right;
		background-size: contain;
		background-repeat: no-repeat;
		background-color: #212121;
		opacity: 0.6;
		position: absolute;
		top: 0px;
		right: 0px;
		bottom: 0px;
		left: 0px;
		z-index: -1;
	}
	.small-text {
		font-size: 12px;
		margin-left: 1.4rem;
		padding-top: 0.5rem;
		white-space: break-spaces;
		color: #a8a8b1;
	}
	@keyframes hideMe {
		0% {
			opacity: 0.6;
		}
		100% {
			opacity: 1;
			height: 135px;
		}
	}
	@keyframes mymove {
		from {
			height: 135px;
		}
		to {
			height: 80px;
		}
	}
	.candle-icon {
		position: absolute;
		right: 16px;
		top: 16px;
		width: 100px;
	}
	.wallet-icon {
		position: relative;
		width: 34px;
		margin-left: 30px;
	}
	.box {
		display: flex;
		width: 100px;
		height: 65px;
		background-color: #e4e5e6;
		position: relative;
		bottom: 2.4rem;
		right: 3rem;
		&.interface {
			left: 5px;
		}
		.container {
			margin-left: 1rem;
			margin-top: 0.5rem;
			.sell {
				border: 1px solid #000000;
				width: 70px;
				height: 20px;
				color: #000;
				.label {
					font-size: 12px;
					position: relative;
					bottom: 3px;
					left: 20px;
				}
			}
			.buy {
				width: 70px;
				height: 20px;
				border: 1px solid #000000;
				margin-top: 0.5rem;
				color: #fff;
				background-color: #000;
				.label {
					font-size: 12px;
					position: relative;
					bottom: 4px;
					left: 20px;
				}
			}
		}
	}
	.btn-conatiner {
		margin-top: 1rem;
		.ant-btn {
			height: 48px;
		}
	}
	@media (max-width:600px) {
    	width: 100%;
	} 
	@media (max-width:500px) {
        .hosting-form {
            width: 350px !important;
            margin-right: auto;
            margin-left: auto;
        }
    } 
	@media (max-width:450px) {
		.animation-container-wrapper{
			display: flex;
			justify-content: center;
			.animation-container {
				width: 300px;
				.comment-box {
					width: auto;
				}
			}
		}
    } 
`;

export const ConfirmationWrapper = styled.div`
	padding-top: 0;
	.ConfirmationWrapper {
	}
	.enterprise-form {
		padding: 24px;
	}
	.mt-1 {
		margin-top: 0.5rem !important;
	}
	.mb-1 {
		margin-bottom: 0.5rem !important;
	}
	.m-2 {
		margin: 1rem;
	}
	.payment-icon {
		margin: 0.5rem;
		width: 3rem;
	}
	.enterprise-icon {
		width: 2rem;
	}
	.d-flex {
		display: flex;
	}
	.content-text-medium {
		font-size: 12px;
	}
	.content-text-small {
		font-size: 11px;
	}
	.content-text-mini {
		color: #a8a8b1;
		font-size: 10px;
	}
	.head {
		font-weight: bold;
	}
	.description-wrapper {
		border-bottom: 0px !important;
		padding-bottom: 10px !important;
	}
	.form-container {
		width: 70%;
		background-color: #29292c;
		.ant-form-item-control {
			line-height: normal;
		}
		.ant-radio-group,
		.ant-input {
			margin: 0.5rem 0px;
		}
	}
	.details-wrapper {
		margin: auto;
		.detail-icon {
			font-size: 18px;
			margin: 0px 5px;
		}
		.detail-font-diy {
			color: #ff9900;
		}
		.anticon {
			color: #ffffff;
		}
	}
	.btn-area {
		margin-top: 1.5rem;
		display: flex;
		> * {
			flex: 1;
		}
		.local {
			line-height: 1;
		}
		button {
			font-weight: normal !important;
		}
		.separator {
			margin: 0 0.5rem;
			flex: none;
		}
	}
	.box-container {
		.content-wrapper {
			.content {
				margin: 0;
				border-color: #808083;
			}
			.popular-container:nth-child(2) {
				.content {
					border-left: none;
					border-right: none;
				}
			}
			.popular-label {
				margin: 0rem;
				width: 100%;
			}
		}
	}
	.do-it-title {
		color: #ffffff;
	}
	.ant-btn-primary {
		color: #fff;
		background-color: #3a4fff;
		border-color: #3a4fff;
	}
	.ant-btn-primary:disabled {
		color: #fff;
		background-color: #42454d;
		border-color: #42454d;
	}
`;

export const CompleteWrapper = styled.div`
	width: 540px;
	margin: auto;
	padding-top: 54px;
	text-align: center;
	h2 {
		margin-bottom: 11px;
	}
	p {
		font-size: 12px;
		line-height: 19px;
	}
	.pc-img {
		margin-top: 22px;
		width: 80%;
	}
	.btn-area {
		padding-top: 22px;
		display: flex;
		> * {
			flex: 1;
			margin: 0 5px;
		}
		.ant-btn {
			background-color: #fff;
			border-color: #00f;
			&.ant-btn-primary {
				background-color: #00f;
			}
		}
	}
`;

export default Wrapper;
